import { merge } from 'lodash';

// Single source of truth for dashboard colors so every chart/tile reads as one system.
export const PALETTE = {
  ink: '#0b1324',
  text: '#0f172a',
  muted: '#64748b',
  subtle: '#94a3b8',
  border: '#e5e9f0',
  grid: '#eef1f6',
  primary: '#0284c7',
  primarySoft: '#e0f2fe',
  cyan: '#06b6d4',
  violet: '#7c3aed',
  success: '#10b981',
  danger: '#f43f5e',
  warning: '#f59e0b',
  slate: '#cbd5e1',
  sky: '#0284c7',
  teal: '#14b8a6'
};

export const SERIES_COLORS = [
  PALETTE.primary,
  PALETTE.cyan,
  PALETTE.violet,
  PALETTE.warning,
  PALETTE.success,
  PALETTE.danger
];

export const FONT_FAMILY =
  "'Inter Tight', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

const baseOptions = {
  chart: {
    fontFamily: FONT_FAMILY,
    foreColor: PALETTE.muted,
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { enabled: true, easing: 'easeinout', speed: 450 }
  },
  grid: {
    borderColor: PALETTE.grid,
    strokeDashArray: 4,
    padding: { left: 8, right: 8, top: 0 }
  },
  xaxis: {
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { fontSize: '12px', fontWeight: 500 } }
  },
  yaxis: {
    labels: { style: { fontSize: '12px' } },
    title: { style: { fontSize: '12px', fontWeight: 500, color: PALETTE.subtle } }
  },
  dataLabels: { enabled: false },
  legend: {
    fontSize: '13px',
    fontWeight: 500,
    labels: { colors: PALETTE.text },
    markers: { size: 5, shape: 'circle', width: 10, height: 10, radius: 10 },
    itemMargin: { horizontal: 10, vertical: 4 }
  },
  tooltip: { theme: 'light', style: { fontSize: '13px' } },
  states: {
    hover: { filter: { type: 'darken', value: 0.92 } },
    active: { filter: { type: 'none' } }
  }
};

export const chartOptions = (overrides = {}) => merge({}, baseOptions, overrides);

export const barOptions = (overrides = {}) =>
  chartOptions(
    merge(
      {
        plotOptions: {
          bar: {
            columnWidth: '46%',
            borderRadius: 6,
            borderRadiusApplication: 'end'
          }
        },
        stroke: { show: true, width: 3, colors: ['transparent'] },
        fill: { opacity: 1 }
      },
      overrides
    )
  );

export const abbreviateBranch = (branchName) => {
  if (!branchName) return '';
  return branchName
    .replace(/Chi nhánh\s*/gi, '')
    .trim()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};
